module.exports = __webpack_public_path__ + "media/images/common/search_btn_s_ov-30d769964208c8a97195340e65c4c7bf.png";